import { get_active_organization_id, get_current_organization_permissions, is_active_organization_public } from "@/utils/organization_profile";
import { has_organization_permission } from "@/utils/organization_permission_helpers";

const permission_update_handlers = new WeakMap();

function parse_user_details() {
  return { user_role: localStorage.getItem("user_role") || "" };
}

function can_create(feature_keys, require_explicit_permission = false) {
  if (!feature_keys || (Array.isArray(feature_keys) && !feature_keys.length)) return true;
  const user_details = parse_user_details();
  const role = String(user_details?.user_role || "").trim().toLowerCase();

  if (["admin", "organization admin", "organisation admin"].includes(role)) return true;
  if (!get_active_organization_id()) return false;
  if (!require_explicit_permission && is_active_organization_public()) return true;

  return has_organization_permission({
    featureKeys: Array.isArray(feature_keys) ? feature_keys : [feature_keys],
    permissionName: "create",
    permissions: get_current_organization_permissions(),
    userRole: role,
    adminRoles: ["admin", "organization admin", "organisation admin"],
  });
}

function update_visibility(element, binding) {
  if (element.dataset.permissionDisplay === undefined) {
    element.dataset.permissionDisplay = element.style.display || "";
    element.dataset.permissionDisplayPriority = element.style.getPropertyPriority("display") || "";
  }

  if (can_create(binding.value, !!binding.modifiers?.permission)) {
    element.style.setProperty(
      "display",
      element.dataset.permissionDisplay,
      element.dataset.permissionDisplayPriority
    );
    return;
  }

  element.style.setProperty("display", "none", "important");
}

export default {
  mounted(element, binding) {
    update_visibility(element, binding);
    const handler = update_visibility.bind(null, element, binding);
    permission_update_handlers.set(element, handler);
    window.addEventListener("organization-permissions-updated", handler);
  },
  updated: update_visibility,
  beforeUnmount(element) {
    const handler = permission_update_handlers.get(element);
    if (!handler) return;
    window.removeEventListener("organization-permissions-updated", handler);
    permission_update_handlers.delete(element);
  },
};
